import { env } from '@/config/env';
import { RedirectsFormFieldsNames, TRedirectFormValues } from '../helpers/types';
import { ICreateRedirectDTO, RedirectType } from '@/models/redirects.model';

class CreateRedirectDTO implements ICreateRedirectDTO {
  type: RedirectType;
  source: string;
  target: string;

  constructor(values: TRedirectFormValues) {
    this.type = values[RedirectsFormFieldsNames.TYPE];
    this.source = values[RedirectsFormFieldsNames.SOURCE].startsWith(env.WEBSITE_URL)
      ? values[RedirectsFormFieldsNames.SOURCE]
      : `${env.WEBSITE_URL}${
          values[RedirectsFormFieldsNames.SOURCE].startsWith('/')
            ? values[RedirectsFormFieldsNames.SOURCE]
            : `/${values[RedirectsFormFieldsNames.SOURCE]}`
        }`;
    this.target = values[RedirectsFormFieldsNames.TARGET].startsWith(env.WEBSITE_URL)
      ? values[RedirectsFormFieldsNames.TARGET]
      : `${env.WEBSITE_URL}${
          values[RedirectsFormFieldsNames.TARGET].startsWith('/')
            ? values[RedirectsFormFieldsNames.TARGET]
            : `/${values[RedirectsFormFieldsNames.TARGET]}`
        }`;
  }
}

export default CreateRedirectDTO;
